import React from 'react';
import { connect } from 'react-redux';

import { PAYMENT_THRESHOLD, IS_DEV } from '../../../../constants';

import { reset } from '../../../../services/account/paymentrequest/request/actions';
import { reset as resetIban } from '../../../../services/account/iban/actions';

import {
    getOnGoingPaymentRequests,
    getOnGoingPaidAmount,
    getOnGoingPaidAmountFormatted,
    isCurrentOnGoingPaymentRequests,
    isFetching
} from '../../../../services/account/paymentrequest/ongoing/selector';
import { getValidatedAmount } from '../../../../services/account/gains/selector';
import * as paymentRequestSelector from '../../../../services/account/paymentrequest/request/selector';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import PaymentRequestIbanComponent from './payment-request/PaymentRequestIbanComponent';

import { InfoAccountComponent } from '../InfoAccountComponent';
import SuccessMessageComponent from '../../../form-message/SuccessMessageComponent';

import './PaymentAreaComponent.scss';

class PaymentAreaComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showFormPaymentRequest: true
        };
    }

    componentWillUnmount() {
        const { reset, resetIban, timeoutId } = this.props;

        clearTimeout(timeoutId);
        reset();
        resetIban();
    }

    handleClosePaymentSuccess = () => {
        const { reset, timeoutId } = this.props;
        clearTimeout(timeoutId);
        reset();
    };

    handleCloseIbanSuccess = () => {
        this.props.resetIban();
    };

    renderGetCashbackButton = () => {
        const { i18n } = this.props;

        // Déterminer la valeur sélectionnée en fonction de l'état
        const selectedValue = this.getSelectedValue();

        return (
            <div className="buttonWrapper">
                <div className="content">
                    <p>{i18n.GOOD_NEWS}</p>
                    <p>
                        {convertHtmlToReactDomWithParams(
                            i18n.TRESHOLD_REACHED_PAYMENT_METHOD_SELECT,
                            PAYMENT_THRESHOLD
                        )}
                    </p>
                    <p>{i18n.CHOOSE_PAYMENT_SOLUTION}</p>

                    <div className="select">
                        <select onChange={this.handleChange} value={selectedValue}>
                            <option value="my-account">{i18n.MY_ACCOUNT}</option>
                        </select>
                    </div>
                </div>
            </div>
        );
    };

    getSelectedValue = () => {
        if (this.state.showFormPaymentRequest) return 'my-account';
        return 'my-account';
    };

    renderCurrentPayment = () => {
        const { i18n, paymentRequests, onGoingPaymentRequests, onGoingPaymentRequestTotalAmount } =
            this.props;

        if (IS_DEV && onGoingPaymentRequests) {
            return (
                <div>
                    {paymentRequests.length > 1 ? (
                        <InfoAccountComponent>
                            {convertHtmlToReactDomWithParams(
                                i18n.PAYMENT_ONGOING_1_MULTI,
                                onGoingPaymentRequestTotalAmount
                            )}
                            <br />
                            {i18n.PAYMENT_ONGOING_2_MULTI}
                        </InfoAccountComponent>
                    ) : (
                        <InfoAccountComponent>
                            {convertHtmlToReactDomWithParams(
                                i18n.PAYMENT_ONGOING_1_SOLO,
                                onGoingPaymentRequestTotalAmount
                            )}
                            <br />
                            {i18n.PAYMENT_ONGOING_2_SOLO}
                        </InfoAccountComponent>
                    )}
                </div>
            );
        }
        return null;
    };

    handleChange = e => {
        const { reset, timeoutId } = this.props;

        clearTimeout(timeoutId);
        reset();

        switch (e.target.value) {
            case 'my-account':
                this.setState({
                    showFormPaymentRequest: true,
                    showFormPepiniere: false,
                    showFormAssociation: false
                });
                break;
            default:
        }
    };

    renderPaymentRequestFormComponent = () => {
        if (this.state.showFormPaymentRequest) {
            return <PaymentRequestIbanComponent />;
        }
    };

    render = () => {
        const {
            i18n,
            i18nIban,
            validatedCashbackAmount,
            paymentRequestTotalAmount,
            successSubmit,
            createIbanSuccess
        } = this.props;

        const thresholdReached =
            validatedCashbackAmount - paymentRequestTotalAmount >= PAYMENT_THRESHOLD;

        return (
            <div id="paymentAreaAnchor">
                <div className="txtcenter-mob bt-recup-cagnotte">
                    {this.renderCurrentPayment()}
                    {thresholdReached && this.renderGetCashbackButton()}
                    {thresholdReached && this.renderPaymentRequestFormComponent()}
                    {!thresholdReached && (
                        <div className="threshold">
                            {convertHtmlToReactDomWithParams(
                                i18n.TRESHOLD_MESSAGE,
                                PAYMENT_THRESHOLD
                            )}
                        </div>
                    )}

                    <SuccessMessageComponent
                        visible={createIbanSuccess}
                        message={i18nIban.CREATE_IBAN_SUCCESS}
                        onClose={this.handleCloseIbanSuccess}
                    />
                    <SuccessMessageComponent
                        visible={successSubmit}
                        message={i18n.SUCCESS_MESSAGE}
                        onClose={this.handleClosePaymentSuccess}
                    />
                </div>
            </div>
        );
    };
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT,
        i18nIban: state.i18n.page.ACCOUNT.PROFILE.IBAN,
        paymentRequests: getOnGoingPaymentRequests(state),
        onGoingPaymentRequestTotalAmount: getOnGoingPaidAmountFormatted(state),
        onGoingPaymentRequests: isCurrentOnGoingPaymentRequests(state),
        isFetchingOnGoingPaymentRequests: isFetching(state),
        validatedCashbackAmount: getValidatedAmount(state),
        paymentRequestTotalAmount: getOnGoingPaidAmount(state),
        successSubmit: paymentRequestSelector.isSuccess(state),
        timeoutId: paymentRequestSelector.getTimeoutId(state),
        createIbanSuccess: state.account.iban.createIbanSuccess
    };
};

const mapDispatchToProps = {
    reset,
    resetIban
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentAreaComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/PaymentAreaComponent.js